
import { Component, Prop, Vue } from 'vue-property-decorator'
import { type OpenMiniProgramOptionType, openMiniProgram } from '@xt/client/utils/mini'
import LazyImg from '@/components/lazyImg/index.vue'

export type WxImgPopOptionType = {
  courseType: 'day' | 'show'
  qrcodeUrl: string
  openMiniProgramOption: OpenMiniProgramOptionType
}

@Component({
  components: {
    LazyImg
  }
})
export default class WxImgPop extends Vue {
  visible: boolean = false
  courseType: 'day' | 'show' = 'day'
  qrcodeUrl: string = ''
  openMiniProgramOption: OpenMiniProgramOptionType = {
    miniProgrmType: 'uc'
  }

  // 打开弹窗，暴露给外部组件使用
  openPop(option: WxImgPopOptionType) {
    const { courseType, qrcodeUrl, openMiniProgramOption } = option
    this.courseType = courseType
    this.qrcodeUrl = qrcodeUrl
    this.openMiniProgramOption = openMiniProgramOption
    this.visible = true
  }

  // 关闭弹窗
  hidePop() {
    this.visible = false
  }

  async handleOpenPCMini() {
    const { miniProgrmType, path, query } = this.openMiniProgramOption
    try {
      const { success, reason } = await openMiniProgram(miniProgrmType, path ?? '', query)
      if (!success) {
        this.$message.error(reason || '打开小程序失败')
      }
    } catch (e) {
      this.$message.error('系统错误')
    }
  }
  created() {}
}
